import React from "react";
import "./Qrcode.css";
import {Button} from "@mui/material";
import Box from "@mui/material/Box";
export default function DisplayQrcode(props) {
    return <Box sx={{p:2}}>
        <img src={props.qrcode} alt="qrcode"/>
        <Button
            variant="contained"
            color="success"
            href={props.qrcode}
            download="qrcode.png"
        >
            Download
        </Button>

    </Box>;
}